import {
  AppleLogo,
  FacebookLogo,
  GooglePlayLogo,
  InstagramLogo,
  LinkedinLogo,
  TiktokLogo,
} from "phosphor-react";
import React, { useRef } from "react";

import footerWave from "~/images/footer_wave2.svg";
import LogoBlock from "./LogoBlock";
import { Link } from "react-router-dom";
import CustomModal from "./CustomModal";
import DownloadAppButton from "~/landingPage/components/buttons/DownloadAppButton";
import { FB_LINK, INSTA_LINK } from "~/utils/Constants";

export default function Footer() {
  const instagramModal = useRef();
  const linkedInModal = useRef();
  const facebookModal = useRef();
  const tiktokModal = useRef();
  const downloadModal = useRef();

  return (
    <div>
      <img src={footerWave} alt="" className="w-full" />
      <section className="w-full bg-[#D7D5EC] text-gray-700 flex flex-col items-center justify-center space-y-12">
        <div className="flex flex-col space-y-6 items-center justify-center mb-8">
          <p className="md:-mt-6 font-semibold text-3xl text-primary">
            Téléchargez Influx
          </p>
          <div className="flex md:flex-row flex-col md:space-x-10 md:space-y-0 space-y-4 justify-between md:justify-center md:items-center">
            <DownloadAppButton
              logo={<AppleLogo size="22" />}
              text={"Depuis l'App Store"}
              onclick={() => downloadModal.current?.open()}
            ></DownloadAppButton>
            <DownloadAppButton
              logo={<GooglePlayLogo size="22" />}
              text={"Depuis Google Play"}
              onclick={() => downloadModal.current?.open()}
            ></DownloadAppButton>
          </div>
        </div>
        <div>
          <div className="mx-auto flex flex-row justify-center items-center md:space-x-6 space-x-4 w-fit h-fit border-2 border-gray-200 rounded-lg py-2 px-4">
            <LogoBlock
              logo={<InstagramLogo />}
              logoName="Instagram"
              onClick={() => window.open(INSTA_LINK)}
            />
            <div className="h-11 w-[2px] bg-gray-200"></div>
            <LogoBlock
              logo={<LinkedinLogo />}
              logoName="LinkedIn"
              onClick={() => linkedInModal.current?.open()}
            />
            <div className="h-11 w-[2px] bg-gray-200"></div>
            <LogoBlock
              logo={<FacebookLogo />}
              logoName="Facebook"
              onClick={() => window.open(FB_LINK)}
            />
            <div className="h-11 w-[2px] bg-gray-200"></div>
            <LogoBlock
              logo={<TiktokLogo />}
              logoName="Tiktok"
              onClick={() => tiktokModal.current?.open()}
            />
          </div>
        </div>
        <div className="h-[2px] bg-gray-400/30 w-3/4 m-auto"></div>

        <div className="w-[90%] flex flex-col sm:flex-row justify-center items-center space-x-2">
          <Link to={`/contact`} className="hover:text-gray-500">
            Contact
          </Link>
          <p className="hidden sm:block">|</p>
          <Link to={`/rgpd`} className="hover:text-gray-500">
            Politique de confidentialité
          </Link>
          <p className="hidden sm:block">|</p>
          <Link to={`/cgu`} className="hover:text-gray-500">
            Conditions générales d'utilisation
          </Link>
          <p className="hidden sm:block">|</p>
          <a href="/" className="hover:text-gray-500">
            Mentions légales
          </a>
        </div>
        <div className="text-gray-700 text-sm">
          &copy; Tous droits réservés{" "}
          <span className="font-semibold">Influx</span> 2023
        </div>
        <div>
          <CustomModal
            ref={instagramModal}
            header="instagram"
            body="Suivez-nous prochainement sur instagram"
          />
          <CustomModal
            ref={linkedInModal}
            header="linkedIn"
            body="Suivez-nous prochainement sur linkedIn"
          />
          <CustomModal
            ref={facebookModal}
            header="facebook"
            body="Suivez-nous prochainement sur facebook"
          />
          <CustomModal
            ref={tiktokModal}
            header="tiktok"
            body="Suivez-nous prochainement sur tiktok"
          />
          <CustomModal
            ref={downloadModal}
            header="Téléchargement"
            body={
              "L'application mobile sera très prochainement disponible sur Google Play et l'App Store, merci de patienter encore un peu. N'hésitez pas à nous contacter pour plus d'informations !"
            }
          />
        </div>
      </section>
    </div>
  );
}
